<template lang="pug">
.discussion
  .conversationInfoContainer
    .conversationInfo
      vue-object-img(
        v-for='user in users',
        :object='user',
        :key='user.id')
      | {{users | users}}
  .messages(v-if='conversation', ref='messages')
    .waiting.text-center.text-muted
      | {{$t('chat.discussion.with')}} {{users | users}}
      br
      br
      vue-object-img(
        v-for='user in users',
        :object='user',
        :key='user.id')
      br
      br
      i.fa.fa-refresh.fa-spin(v-if='status === STATUS.LOADING')
      template(v-if='status === STATUS.LOADED && messages.length == 0') {{$t('chat.discussion.beTheFirst')}}
    .message(v-for="message in messages", :key='message.id', :class='{inverted: message.sender.id === user.id}', v-if='conversation')
      vue-object-img(:object="message.sender")
      .date {{message.time | unixtimeTo('LLL')}}
      .text
        embed-text(:options='embedOptions', @done='goToBottom') {{message.text}}
      br
    .isWriting(v-if="isWriting")
      .text {{$t("conversations.isWriting")}}
  .answer
    input.form-control(:placeholder='$t("chat.discussion.messagePlaceholder")', v-model='newMessage', @keydown.enter='sendMessage', ref='input', @focus="takeInput", @blur="releaseInput")
    a.btn.btn-default(@click="sendMessage") {{$t('globals.send')}}
</template>
<script>
import VueObjectImg from '@/components/shared/VueObjectImg'
import EmbedText from '@/components/shared/EmbedText'
import STATUS from '@/utils/status'

import _ from 'lodash'
import $ from 'jquery'

import api from '@/utils/api'

import {unixtimeTo, users} from '@/components/shared/vue.globals'

export default {
  props: {
    users: {
      required: true
    }
  },
  data () {
    return {
      chatInfo: null,
      newMessage: '',
      inInput: false,
      isWriting: false,
      embedOptions: {
        preset: {
        }
      },
      STATUS
    }
  },
  components: {
    VueObjectImg,
    EmbedText
  },
  mounted () {
    window.api = api
    this.loadChatConversation()
    this.$nextTick(() => {
      this.$refs.input.focus()
    })
    $(window).on('resize.chatConversation', () => {
      this.goToBottom()
    })
    this.updateOnAppwire = (data) => {
      // console.log(data)
      if (data.action === 'newMessage' && data.cId === this.conversation.id && data.uId !== this.user.id) {
        if (this.conversation.refreshMessages) {
          return
        }
        this.conversation.refreshMessages = true
        api.get('/messages', {params: {
          convId: this.conversation.id,
          markAsRead: false
        }}).then((response) => {
          this.isWriting = false
          this.$set(this.conversation, 'messages', response.data.messages)
          this.$set(this.conversation, 'unreadMessages', response.data.unreadMessages)
          this.$set(this.conversation, 'participants', response.data.participants)
          this.conversation.refreshMessages = false
        }).catch(() => {
          this.conversation.refreshMessages = false
        })
      } else {
        if (data.action === 'writing' && data.cId === this.conversation.id && data.uId !== this.user.id) {
          this.isWriting = true
          if (this.timeoutWriting != null) {
            clearTimeout(this.timeoutWriting)
          }
          this.timeoutWriting = setTimeout(() => {
            this.isWriting = false
            this.timeoutWriting = null
          }, 5000)
        }
      }
    }
    this.$appwireEvents.$on('conversations', this.updateOnAppwire)
    this.$watch('newMessage', _.debounce(() => {
      if (this.conversation.inCreation || this.conversation.id < 0) {
        return
      }
      this.draftStatus = STATUS.SAVING
      api.put('/conversation/' + this.conversation.id, {draft: this.newMessage}).then(() => {
        this.draftStatus = STATUS.SAVED
      }).catch(() => {
        this.draftStatus = STATUS.ERROR
      })
    }, 500))
  },
  destroyed () {
    $(window).off('resize.chatConversation')
    this.$appwireEvents.$off('conversations', this.updateOnAppwire)
  },
  computed: {
    user () {
      return this.$store.getters['user/user']
    },
    messages () {
      return _.sortBy(this.conversation.messages, ['time', 'id'])
    },
    conversation () {
      return this.chatInfo && this.chatInfo.conversation
    },
    status () {
      return this.chatInfo && this.chatInfo.status
    }
  },
  methods: {
    loadChatConversation () {
      this.chatInfo = null
      this.$store.dispatch('chat/getChatFor', [...this.users, this.user]).then((chatInfo) => {
        _.each(this.users, (u) => {
          if (!u.name) {
            let p = _.find(chatInfo.users, {id: u.id})
            for (let k in p) {
              this.$set(u, k, p[k])
            }
          }
        })
        this.chatInfo = chatInfo
        this.$store.dispatch('chat/setAsRead', this.chatInfo)
      }).catch(() => {
        this.chatInfo = null
      })
    },
    sendMessage () {
      let newMessage = this.newMessage
      this.newMessage = ''
      this.$store.dispatch('conversations/sendMessage', {conversation: this.conversation, message: newMessage})
      this.$refs.input.focus()
    },
    goToBottom () {
      if (this.$refs.messages) {
        this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight
      }
    },
    markAsRead () {
      if (this.chatInfo) {
        this.$store.dispatch('chat/setAsRead', this.chatInfo)
      }
    },
    takeInput () {
      this.inInput = true
      this.markAsRead()
    },
    releaseInput () {
      this.inInput = false
    }
  },
  filters: {
    unixtimeTo,
    users
  },
  watch: {
    users (newValue, oldValue) {
      if (!_.isEqual(newValue, oldValue)) {
        this.loadChatConversation()
        this.isWriting = false
      }
    },
    'conversation.messages': function () {
      this.$nextTick(() => {
        this.goToBottom()
        if (this.inInput) {
          this.markAsRead()
        }
      })
    }
  }
}
</script>
<style lang="sass">
.discussion
  height: 100%
  position: relative
  .waiting
    padding: 50px
    .profileImage
      $size: 50px
      height: $size
      line-height: $size
      width: $size
  .conversationInfoContainer
    position: absolute
    width: 100%
    overflow: hidden
    padding-bottom: 10px
    z-index: 98
    .conversationInfo
      padding: 15px 10px 11px 10px
      box-shadow: 0 0px 10px rgba(0,0,0,0.4)
      width: 100%
      background-color: #5eaee3
      color: white
      font-size: 0.8em
      .profileImage
        $size: 20px
        height: $size
        line-height: $size
        width: $size    
        margin-right: 5px
        margin-top: -2px
  .messages
    overflow: auto
    max-height: calc(100% - 40px)
    padding: 20px
    position: absolute
    width: 100%
    bottom: 40px
    overflow: auto      
    .message
      padding: 5px
      $size: 30px
      min-height: $size + 10
      position: relative
      .profileImage
        height: $size
        line-height: $size
        width: $size
        position: absolute
      .date
        font-size: 0.7em
        display: none
        position: absolute
        top: -10px
        left: $size + 20
        opacity: 0.8
      &:hover .date
        display: block        
      .text
        display: inline-block
        margin-left: $size + 10
        padding: 5px 10px
        background-color: white
        // box-shadow: 5px 5px 5px rgba(0,0,0,0.3)
        border-radius: 10px
        margin-bottom: 10px
        white-space: pre-line
        .ejs-preview
          width: 100%
      &.inverted
        text-align: right
        .profileImage
          right: 0
        .date
          top: -10px
          right: $size + 20
        .text
          display: inline-block
          margin-left: 0
          margin-right: $size + 10
          text-align: left
  .isWriting
    position: absolute
    bottom: 50
    left: 5px
    font-size: 10px
    color: rgba(0,0,0,0.5)


  .answer
    position: absolute
    bottom: 0
    left: 0
    right: 0
    padding: 5px
    input
      width: calc(100% - 100px)
      display: inline-block
    .btn
      width: 100px
</style>



// WEBPACK FOOTER //
// ChatConversation.vue?5bdeb602